import { IGatsbyImageData } from 'gatsby-plugin-image';

export const useContentfulImage = (
  url: string,
  size = 460,
): IGatsbyImageData => {
  return {
    images: {
      sources: [
        {
          srcSet: `${url}?w=${size / 4}&h=${
            size / 4
          }&q=80&r=2&fit=thumb&fm=avif ${size / 4}w, ${url}?w=${size / 2}&h=${
            size / 2
          }&q=80&r=2&fit=thumb&fm=avif ${
            size / 2
          }w, ${url}?w=${size}&h=${size}&q=80&r=2&fit=thumb&fm=avif ${size}w, ${url}?w=${
            size * 2
          }&h=${size * 2}&q=80&r=2&fit=thumb&fm=avif ${size * 2}w`,
          sizes: `(min-width: ${size}px) ${size}px, 100vw`,
          type: 'image/avif',
        },
        {
          srcSet: `${url}?w=${size / 4}&h=${
            size / 4
          }&q=80&r=2&fit=thumb&fm=webp ${size / 4}w, ${url}?w=${size / 2}&h=${
            size / 2
          }&q=80&r=2&fit=thumb&fm=webp ${
            size / 2
          }w, ${url}?w=${size}&h=${size}&q=80&r=2&fit=thumb&fm=webp ${size}w, ${url}?w=${
            size * 2
          }&h=${size * 2}&q=80&r=2&fit=thumb&fm=webp ${size * 2}w`,
          sizes: `(min-width: ${size}px) ${size}px, 100vw`,
          type: 'image/webp',
        },
      ],
      fallback: {
        src: `${url}?w=${size}&h=${size}&fl=progressive&q=80&r=2&fit=thumb&fm=jpg`,
        srcSet: `${url}?w=${size / 4}&h=${
          size / 4
        }&fl=progressive&q=80&r=2&fit=thumb&fm=jpg ${size / 4}w, ${url}?w=${
          size / 2
        }&h=${size / 2}&fl=progressive&q=80&r=2&fit=thumb&fm=jpg ${
          size / 2
        }w, ${url}?w=${size}&h=${size}&fl=progressive&q=80&r=2&fit=thumb&fm=jpg ${size}w, ${url}?w=${
          size * 2
        }&h=${size * 2}&fl=progressive&q=80&r=2&fit=thumb&fm=jpg ${size * 2}w`,
        sizes: `(min-width: ${size}px) ${size}px, 100vw`,
      },
    },
    layout: 'constrained',
    width: size,
    height: size,
  };
};
